import { FieldProps } from 'formik';
import React from 'react';
import { MunicipalityInvoiceHelper } from '../../../@types/model/transformer/invoice/municipalityInvoice';
import WhiteTextField from '../../customComponents/textField/WhiteTextField';
import { IRootState } from '../../../@types/redux';
import { IValueAddedTax } from '../../../@types/model/masterData/valueAddedTax/valueAddedTax';
import { connect } from 'react-redux';
import MasterDataValueAddedTaxFunctions from '../../../store/masterData/valueAddedTax/functions';

interface IMunicipilityInvoiceVatFormFieldProps extends FieldProps<number | null> {
    valueAddedTaxes : Array<IValueAddedTax>;
}

interface IMunicipilityInvoiceVatFormFieldState {}

class MunicipilityInvoiceVatFormFieldComponent extends React.PureComponent<IMunicipilityInvoiceVatFormFieldProps, IMunicipilityInvoiceVatFormFieldState> {
    constructor(props : IMunicipilityInvoiceVatFormFieldProps) {
        super(props);
        this.state = {};
    }

    private readonly onChange = (event : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.props.form.handleChange(event);
        this.props.form.setFieldTouched(this.props.field.name, true);
        setTimeout(() => {
            MunicipalityInvoiceHelper.calculateTotals(this.props.form, this.props.valueAddedTaxes);
        });
    };

    public readonly componentDidMount = () => {
        this.loadVatMasterData();
    };
    
    private readonly loadVatMasterData = () => {
        MasterDataValueAddedTaxFunctions.load();
    };

    public readonly render = () => {
        const {
            field,
        } = this.props;
        return (
            <WhiteTextField
                {...field}
                value={field.value ?? ''}
                variant='standard'
                label='VAT Rebill'
                fullWidth
                type='number'
                onChange={this.onChange}
            />
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return {
        valueAddedTaxes: state.masterData.valueAddedTax.valueAddedTaxes,
    };
};
    
const MunicipilityInvoiceVatFormField = connect(
    mapStateToProps,
)(MunicipilityInvoiceVatFormFieldComponent);

export default MunicipilityInvoiceVatFormField;